module.exports = __webpack_public_path__ + "static/media/DaiDishLoading1.e04b8c5d.gif";